import React from "react";

import { PetsReportFilter } from "./PetsReportFilter";
import { PetsReportSummary } from "./PetsReportSummary";
import { PetsReportTable } from "./PetsReportTable";

export function PetsReport() {
  return (
    <div className="flex w-full flex-col gap-5 pt-5">
      <PetsReportFilter />
      <PetsReportSummary />
      <PetsReportTable />
    </div>
  );
}
